var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaws({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "04-laws",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M45.1,6.1L33.4,2.6c-0.8-0.2-1.7-0.2-2.6,0L19.2,6.1C17.3,6.7,16,8.4,16,10.4v12.8c0,2.5,0.9,4.9,2.8,7.3 c1.2,1.6,2.9,3.1,4.9,4.6c3.3,2.4,6.5,3.8,6.6,3.9c0.6,0.3,1.2,0.4,1.8,0.4c0.6,0,1.2-0.1,1.8-0.4c0.1-0.1,3.4-1.5,6.6-3.9 c2-1.5,3.7-3,4.9-4.6c1.8-2.3,2.8-4.8,2.8-7.3V10.4C48.2,8.4,46.9,6.7,45.1,6.1z M43.7,10.5v12.8c0,1.4-0.6,3-1.8,4.5 c-1,1.2-2.3,2.5-4,3.7c-2.9,2.1-5.7,3.4-5.7,3.4c-0.1-0.1-2.9-1.3-5.8-3.4c-1.7-1.2-3-2.5-4-3.7c-1.2-1.5-1.8-3-1.8-4.5V10.5 L32.1,7L43.7,10.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.4,45.3l2.3,5.6c-0.6,0.2-1.1,0.3-1.7,0.3c-0.6,0-1.2-0.1-1.7-0.4s-1-0.6-1.5-1c-0.4-0.4-0.7-0.9-1-1.5L24.2,47 L7.1,53.8c-0.6,0.2-1.1,0.3-1.7,0.3c-0.6,0-1.2-0.1-1.7-0.4c-0.5-0.2-1-0.6-1.5-1c-0.4-0.4-0.7-0.9-1-1.5l21.3-8.4 c1.1-0.4,2.4-0.4,3.5,0.1C27.1,43.4,28,44.2,28.4,45.3L28.4,45.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35.7,45.3L33.4,51c0.6,0.2,1.1,0.3,1.7,0.3c0.6,0,1.2-0.1,1.7-0.4c0.5-0.2,1-0.6,1.5-1c0.4-0.4,0.7-0.9,1-1.5l0.6-1.4 l17.1,6.8c0.6,0.2,1.1,0.3,1.7,0.3c0.6,0,1.2-0.1,1.7-0.4c0.5-0.2,1-0.6,1.5-1c0.4-0.4,0.7-0.9,1-1.5l-21.3-8.4 c-1.1-0.4-2.4-0.4-3.5,0.1S36.2,44.2,35.7,45.3L35.7,45.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1.2,
    y: 56.1,
    width: 61.8,
    height: 4.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaws);
export default __webpack_public_path__ + "static/media/laws.7798fac8975b416e998bcd517c9a2376.svg";
export { ForwardRef as ReactComponent };